<script setup>
import { useRouter } from 'vue-router'
import AppButton from './AppButton.vue'
import { authUser, isAuthenticated, logout } from '../../features/auth/authSession.js'

const router = useRouter()

async function signOut() {
  try {
    await logout()
  } finally {
    await router.push('/')
  }
}
</script>

<template>
  <header class="app-header screen-only">
    <div class="app-header-inner">
      <RouterLink class="brand-lockup" to="/" aria-label="MIDA 홈">
        <i aria-hidden="true" />
        <strong>MIDA</strong>
      </RouterLink>

      <nav id="main-nav" class="app-nav" aria-label="주요 메뉴">
        <RouterLink to="/upload">분석 시작</RouterLink>
        <RouterLink to="/history">결과이력</RouterLink>
        <template v-if="isAuthenticated">
          <RouterLink v-if="authUser?.role === 'ADMIN'" to="/admin/settings">설정</RouterLink>
          <span class="nav-divider" aria-hidden="true" />
          <span class="user-greeting">{{ authUser.name }} 님</span>
          <AppButton variant="secondary" size="sm" @click="signOut">로그아웃</AppButton>
        </template>
        <template v-else>
          <RouterLink class="nav-cta app-button app-button--primary app-button--sm" to="/login">로그인</RouterLink>
        </template>
      </nav>
      <details :key="$route.fullPath" class="mobile-navigation">
        <summary class="menu-toggle" aria-label="메뉴 열기 / 닫기">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M4 7h16M4 12h16M4 17h16" /></svg>
        </summary>
      <nav id="mobile-nav" class="app-nav is-open" aria-label="모바일 메뉴">
        <RouterLink to="/upload">분석 시작</RouterLink>
        <RouterLink to="/history">결과이력</RouterLink>
        <template v-if="isAuthenticated">
          <RouterLink v-if="authUser?.role === 'ADMIN'" to="/admin/settings">설정</RouterLink>
          <span class="nav-divider" aria-hidden="true" />
          <span class="user-greeting">{{ authUser.name }} 님</span>
          <AppButton variant="secondary" size="sm" @click="signOut">로그아웃</AppButton>
        </template>
        <template v-else>
          <RouterLink class="nav-cta app-button app-button--primary app-button--sm" to="/login">로그인</RouterLink>
        </template>
      </nav>
      </details>

    </div>
  </header>
</template>
